import { AppGlobalState } from 'modules/types'
import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const basicSelectors = createBasicSelectors('pedigreedTargetSku')

export const PedigreedTargetSkuSelectors = {
  ...basicSelectors,
  updateCounter: (state: AppGlobalState) => state.pedigreedTargetSku.updateCounter,
  targetsTotal: (state: AppGlobalState) => state.pedigreedTargetSku.totalTargetValues,
  farmerOrdersTotal: (state: AppGlobalState) => state.pedigreedTargetSku.totalFarmerOrdersSku,
  previousYear: (state: AppGlobalState) => state.pedigreedTargetSku.totalFarmerOrdersSkuPreviousYear,
  growerTargetsTotal: (state: AppGlobalState) => state.pedigreedTargetSku.totalGrowerTargets,
}

export default PedigreedTargetSkuSelectors
